import type { RoadSectionId } from '../../domain/Reference';
import { roadSectionsQuery } from '../../reference/queries';
import { createCommand } from '../../utils';
import { perimeterQuery } from '../queries';
import { selectionFocusRequested } from '../state';
import { ExtendKind, extendSelection } from '../selection';
import { SelectRoadSectionsCommand } from './SelectRoadSectionsCommand';

// "Tout l'axe", "Contigus de même catégorie", "Même gestionnaire sur cet axe": replaces the selection and
// brings it into view. `baseId` is the section the action is about (the right-clicked one, or the first selected).
export const ExtendSelectionCommand = createCommand<{ kind: ExtendKind; baseId: RoadSectionId }>(
    'MAP_V2/EXTEND_SELECTION',
    async ({ kind, baseId }, { dispatch, getState }) => {
        const state = getState();
        const sections = roadSectionsQuery(state);
        const { includes } = perimeterQuery(state);
        const base = sections.find((section) => section.id === baseId);
        if (!base) {
            return;
        }
        // Sections the filters leave out are not added.
        const ids = extendSelection(sections, base, kind).filter((id) => id === base.id || includes(id));
        await dispatch(SelectRoadSectionsCommand({ ids, anchor: base.id }));
        dispatch(selectionFocusRequested());
    },
);
